import { useEffect, useState } from "react";
import Loader from "../Common/Loader";
import { SitePage } from "../../Models/SitePage";
import SitePageApi from "../../Api/SitePageApi";
import FormFillerPage from "../Forms/FormFillerPage";
import FormApi from "../../Api/FormApi";
import { useConferenceData } from "../Conference/useConferenceData";

export default function FallConvention() {
  const [pageData, setPageData] = useState<SitePage>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formId, setFormId] = useState<number>(0);
  const { fallConference, loading: conferenceLoading } = useConferenceData();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        
        // Try to get page/form from the conference event first
        if (fallConference?.id) {
          // First, try to get page directly from event's SitePageId
          if (fallConference.sitePageId) {
            try {
              const pageRes = await SitePageApi.getSitePage(fallConference.sitePageId.toString());
              setPageData(pageRes.data);
              // Still try to get form by event ID
              try {
                const formRes = await FormApi.getFormByEventId(fallConference.id);
                if (formRes.data) {
                  setFormId(formRes.data.formId!);
                }
              } catch (err) {
                console.log("No form found for conference event");
              }
              setIsLoading(false);
              return;
            } catch (err) {
              console.log("Page not found for event SitePageId, trying form");
            }
          }
          
          // Second, try to get form by event ID and use its pageId
          try {
            const formRes = await FormApi.getFormByEventId(fallConference.id);
            if (formRes.data) {
              setFormId(formRes.data.formId!);
              // If form has a pageId, get that page
              if (formRes.data.pageId) {
                const pageRes = await SitePageApi.getSitePage(formRes.data.pageId.toString());
                setPageData(pageRes.data);
                setIsLoading(false);
                return;
              }
            }
          } catch (err) {
            console.log("No form found for conference event, trying fallback");
          }
        }
        
        // Fallback to hardcoded page ID 13 for backward compatibility
        const pageRes = await SitePageApi.getSitePage("13");
        setPageData(pageRes.data);
      } catch (err) {
        console.error("Page not found");
      } finally {
        setIsLoading(false);
      }

      // Try to get form by page ID (fallback)
      if (!formId) {
        try {
          const formRes = await FormApi.getFormByPageId(13);
          if (formRes.data) {
            setFormId(formRes.data.formId!);
          }
        } catch (err) {
          console.error("Form not found for page 13");
        }
      }
    };

    if (!conferenceLoading) {
      loadData();
    }
  }, [fallConference, conferenceLoading]);

  return (
    <>
      <title>{pageData?.title}</title>
      <div className="w-full">
        <div className="w-full p-4">
          <div className="mx-1 flex items-end">
            <div className="flex flex-1">
              <h5 className="text-gray-900 font-bold text-4xl">
                {pageData?.header}
              </h5>
            </div>
          </div>
        </div>
        <div className="p-5">
          {isLoading && <Loader />}
          <div
            dangerouslySetInnerHTML={{
              __html: pageData?.description ?? "",
            }}
          />
          {formId > 0 && (
            <div className="w-full p-4">
              <FormFillerPage formId={formId} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
